module.exports = __webpack_public_path__ + "static/media/ilha_7.7c90eaf8.jpg";